<template>
  <div :style="{direction:$t('direction')}">
    
    <modal @close="modal = false" :open="modal" :maxWitdh="'600px'">
      
      <div class="ar-card">
        <div class="ar-card-header">
          <div class="ar-card-title">
            افزودن پاسخ 
          </div>
          <span>
            <i @click="modal = false" class="mdi mdi-close"></i>
          </span>
        </div>
        <div class="ar-card-body text-right">
          
          <div class="ar-form-group">
            <label>پاسخ خود را بنویسید :</label>
            <textarea v-model="reply" class="ar-form-control" rows="3"></textarea>
          </div>
          
        </div>
        <div class="ar-card-footer">
          <button @click="TicketReply()" class="ar-btn size-sm primary">ثبت</button>
          <button @click="modal = false" class="ar-btn size-sm outline-primary mx-3">انصراف</button>
        </div>
      </div>

    </modal>

    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
          <div class="dashboard-wrapper">
            
            <div class="ar-card">
              <div class="ar-card-header">
                <div>بخش : {{item.section}}</div>
                <div>
                  {{item.date}} - {{item.time}}
                  <button v-if="item.status == 0 || item.status == 1" @click="modal = true" class="ar-btn size-md primary round">پاسخ</button>
                </div>
              </div>
              <div class="ar-card-body">
                <h4>موضوع : {{item.subject}}</h4>
                <pre class="card-text py-2">{{item.text}}</pre>
              </div>
              <template v-if="item.replies">
                <div class="p-3">
                  <div v-for="(data , key) in item.replies" :key="key" class="ar-card my-3" style="overflow: hidden;">
                    <div class="ar-card-header" :class="[
                      data.user_id ? 'bg-primary text-light' : ''
                    ]">
                      <div>
                        <template v-if="data.admin_id">
                        {{data.admin.name}}
                        </template>
                        <template v-if="data.user_id">
                        {{data.user.fullname}}
                        </template>
                      </div>
                      <div>
                        {{data.date}} - {{data.time}}
                      </div>
                    </div>
                    <div class="card-body">
                      <pre class="card-text p-2">{{data.text}}</pre>
                    </div>
                  </div>
                </div>
              </template>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import Modal from '../../components/Modal.vue'
export default {
  name: 'Ticket',
  components:{
    Sidebar,
    Modal,
    Header
  },
  data : () => ({
    loading:false,
    modal:false,
    reply:null,
    item:{},
  }),
  watch:{
    
  },
  methods:{
    getTicketData(id){
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.get(`getTicketData/`+id,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.item = res.data.data
        this.activeLoading(false)
      })
      .catch(err => {
        console.log(err.response);          
        this.activeLoading(false)
        this.$router.push({name:'Tickets'});
      });

    },
    TicketReply(){
      if(!this.reply){
        return
      }
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.post(`replyTicket`,{id:this.item.id , reply:this.reply},
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.getTicketData(this.$route.params.id)
        this.reply = null
        this.modal = false
        this.activeLoading(false)
      })
      .catch(err => {
        this.modal = false         
        this.activeLoading(false)
      });
    }
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()
    this.checkConfirmed()

    if(this.$route.params.id !== ''){
      this.getTicketData(this.$route.params.id)
    }else{
      this.$router.push({name:'Tickets'});
    }
  }
}
</script>
<style>
</style>